import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const ContentWrapper = styled.div`
    display: inline-block;
    margin-left: 1rem;
`;

export class GoToYear extends Component {

    static propTypes = {
        callback: PropTypes.func.isRequired
    }

    state = {};

    componentDidMount() {
    }

    year_select() {
        const options_array = [];
        for (let year = 2021; year >= 1961; year--) {
            options_array.push(year)
        }
        const options = options_array.map(year => <option key={"year_" + year}>{year}</option>)
        return <select onChange={e => this.props.callback(e.target.value)}>
            {options}
        </select>
    }

    render() {
        const year_select = this.year_select();
        return <ContentWrapper>
            year: {year_select}
        </ContentWrapper>
    }
}

export default GoToYear;

